export default __webpack_public_path__ + "static/media/image2.21577de8.jpg";